import Vue from 'vue';
import VueI18n, { I18nOptions } from 'vue-i18n';
/* import enLocale from 'element-ui/lib/locale/lang/en';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import twLocale from 'element-ui/lib/locale/lang/zh-TW'; */

//构造I18nOptioins对象, 并默认从本地缓存获取初始化的语言版本;
let langConf: I18nOptions = { locale: '', messages: {} };

//通过Webpack提供的require.context对象获取当前目录(包含子目录)下的所有文件, 如['/lamg/index.ts', '/lang/zh-CN.ts', '/lang/en.ts', '/lang/sub/lang.zh-CN.ts'];
const files = require.context('@/lang/', true, /\.(js|ts)$/);

//遍历获取到的当前目录下所有的文件;
files.keys().forEach((key: string) => {
	//根据文件路径规则(如:'/lang/index.ts')使用正则匹配出文件名;
	//步骤1: 先从'/lang/zh-CN.ts'或'/lang/sub/lang.zh-CN.ts'中获取'zh-CN.ts'或'lang.zh-CN.ts';
	//步骤2: 然后使用replace将最后的.xx替换为空, 即可获取到正确的文件名'zh-CN'或'lang.zh-CN';
	let filePath: Array<string> = key.match(/[^\/]+/g) as Array<string>;
	const fileName: string = String(filePath.slice(-1)).replace(/\.[^.]+$/, '');

	//如果当前文件不是主文件, 则认为该文件是语言文件, 将该文件的default模块赋值到langConf.messages[文件名]模块;
	//如'/lang/zh-CN.ts'文件不是主文件, 则会将其赋值到langConf.messages['zh-CN']模块下;
	(langConf.messages as any)[fileName.toLowerCase()] = files(key).default; //读取出文件中的default模块
});

if (langConf.messages && langConf.messages['en']) {
	//将Element-UI的en语言包与自定义的en语言包通过解构的方式合并到langConf.messages['en']模块下;
	langConf.messages['en'] = { ...langConf.messages['en'] /* , ...enLocale */ };
}
if (langConf.messages && langConf.messages['zh-cn']) {
	//同上;
	langConf.messages['zh-cn'] = { ...langConf.messages['zh-cn'] /* , ...zhLocale */ };
}
if (langConf.messages && langConf.messages['zh-tw']) {
	//同上;
	langConf.messages['zh-tw'] = { ...langConf.messages['zh-tw'] /* , ...twLocale */ };
}

Vue.use(VueI18n);

const i18n = new VueI18n(langConf);
Vue.mixin({ i18n });

export default i18n;
